import { Box, Flex, Heading, Separator, Text } from '@chakra-ui/react';
import { BaseAlert, BaseButton, BaseFields, BasePopover } from '@cks-internal/react-base';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { usePerformanceFlagStore } from '../../stores/performanceFlagStore';
import { useMemo } from 'react';

export const PerformanceSettings = () => {
  const performanceFlags = usePerformanceFlagStore();

  const allDisabled = useMemo(() => {
    return (
      performanceFlags.disableWorkflow &&
      performanceFlags.disableNewReplyNotifications &&
      performanceFlags.disableMyActivitiesSidebar &&
      performanceFlags.disableSystemMessageNotification &&
      performanceFlags.disableActivityOpenNotification &&
      performanceFlags.disableFooterTabs
    );
  }, [
    performanceFlags.disableWorkflow,
    performanceFlags.disableNewReplyNotifications,
    performanceFlags.disableMyActivitiesSidebar,
    performanceFlags.disableSystemMessageNotification,
    performanceFlags.disableActivityOpenNotification,
    performanceFlags.disableFooterTabs
  ]);

  return (
    <BasePopover
      header={<Heading mb={'12px'}>Performance Settings</Heading>}
      trigger={
        <BaseButton size={'xs'} icon={faGear} toolTip={'Performance Settings'} aria-label={'Performance Settings'} />
      }
      onCancel={() => {}}>
      <BaseAlert>Changing a performance flag will force refresh your browser!</BaseAlert>
      <Box>
        <Flex direction='column' gap={'16px'}>
          <BaseButton
            size='sm'
            variant={allDisabled ? 'primary' : 'secondary'}
            onClick={() => {
              performanceFlags.toggleAll(!allDisabled);
              window.location.reload();
            }}>
            {allDisabled ? 'Enable All' : 'Disable All'}
          </BaseButton>

          <Separator />

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Workflow
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableWorkflow}
              onChangeControlled={(val) => {
                performanceFlags.setDisableWorkflow(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable New Reply Notifications
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableNewReplyNotifications}
              onChangeControlled={(val) => {
                performanceFlags.setDisableNewReplyNotifications(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable My Activities Sidebar
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableMyActivitiesSidebar}
              onChangeControlled={(val) => {
                performanceFlags.setDisableMyActivitiesSidebar(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable System Message Notification
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableSystemMessageNotification}
              onChangeControlled={(val) => {
                performanceFlags.setDisableSystemMessageNotification(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Activity Open Notification
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableActivityOpenNotification}
              onChangeControlled={(val) => {
                performanceFlags.setDisableActivityOpenNotification(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Footer Tabs
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableFooterTabs}
              onChangeControlled={(val) => {
                performanceFlags.setDisableFooterTabs(!!val);
                window.location.reload();
              }}
            />
          </Flex>
        </Flex>
      </Box>

      <Separator />

      <Flex direction='column' gap={'16px'}>
        <Heading size='sm'>Beta Features</Heading>
        <Text fontSize='sm' color='gray.600'>
          Experimental features that are opt-in. These may have issues and are subject to change.
        </Text>

        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            Project Dashboard (Beta)
          </Text>
          <BaseFields.SwitchInput
            checked={performanceFlags.enableProjectAssessments}
            onChangeControlled={(val) => {
              performanceFlags.setEnableProjectAssessments(!!val);
              window.location.reload();
            }}
          />
        </Flex>
      </Flex>

      {
        //need to fix later  <BetaMenu />
      }
    </BasePopover>
  );
};
